import styled from "styled-components";

export const HeadingBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderLeft = styled.div`
  max-width: 540px;
`;